<div class="d-flex justify-content-center">
  <mat-spinner diameter="40" color="accent"></mat-spinner>
</div>
